import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { HttpHeaders } from '@angular/common/http';
import { CurrentUser } from '@shared/interfaces';

import { UserRoleEnum } from '@shared/enums';

import { environment } from '@environments/environment';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class UserApi {
    constructor(private auth0: AuthService, private apiService: ApiService) {}

    async getAuthToken(): Promise<string>{
        return new Promise<string>(resolve =>{
            this.auth0.getAccessTokenSilently({ detailedResponse: true }).subscribe({
                async next(res){
                    resolve(res.access_token);
                }
            });
        });
    }


    async getUserDetails(token: string): Promise<any> {
        return new Promise<any>(resolve => {

            var headers = new HttpHeaders({ 
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
             });

            const url = `${environment.accountsApiUrl}`;
            
            this.apiService.get(url, headers)
                .subscribe({
                    next: (res: any) => {
                        resolve(res);
                    },
                    error: error => {
                        console.error(error.message);
                    }
                });
                    
        });
    }

    getCurrentUserRoles(): Promise<UserRoleEnum[]>{
        return new Promise<UserRoleEnum[]>(async resolve => {

            this.auth0.user$.subscribe(
                (profile : any) => {
                    const roles = profile!['https://transnetyx.com/roles'] || [];
                    resolve(this.mapRoles(roles));
                }
              );
        });
    }

    getCurrentUserId(): Promise<number>{
        return new Promise<number>(async resolve => {

            this.auth0.user$.subscribe(
                (profile : any) => {
                    const idText = profile!['https://transnetyx.com/omUserId'];
                    let id = parseInt(idText);
                    if(isNaN(id)){
                        id = -1;
                    }
                    resolve(id);
                }
              );
        });
    }
//userIdTokenKey

    async getCurrentUserDetails(): Promise<CurrentUser> {
        return new Promise<CurrentUser>((async resolve =>{
            const token = await this.getAuthToken();

            const profile = await this.getUserDetails(token);
            const roles = await this.getCurrentUserRoles();
            const userId = await this.getCurrentUserId();
            
            const user : CurrentUser = {
                id: userId,
                firstName: (profile.firstName ?? '') as string,
                lastName: profile.lastName ?? '',
                shortName: 
                ((profile.firstName ?? '' ) +
                ' ' +
                (profile.lastName ? profile.lastName[0] + '.' : '')) as string,
                longName: ((profile.firstName ?? '') + ' ' + (profile.lastName ?? '')) as string,
                addressLine1: (profile.shippingAddress.addressLine1 ?? '') as string,
                addressLine2: (profile.shippingAddress.addressLine2 ?? '') as string,
                addressLine3: '',
                city: (profile.shippingAddress.city ?? '') as string,
                stateOrProvinceCode: profile.shippingAddress.regionCode ?? '',
                postalCode: (profile.shippingAddress.postalCode ?? '') as string,
                organization: profile.organization as string,
                roles: roles,
                email: (profile.userName ?? '') as string,
                phoneNumber: (profile.phoneNumber ?? '') as string,
                countryCode: profile.shippingAddress.countryCode ?? ''
            };

            resolve(user);
        }));
    }

    private mapRoles(accountsRoles: string[]): UserRoleEnum[] {
        const mappedRoles = [UserRoleEnum.USER];

        if (accountsRoles.includes("Administrator")) {
            mappedRoles.push(UserRoleEnum.ADMIN);
        }

        if (accountsRoles.includes("Wellplate Overpack")) {
            mappedRoles.push(UserRoleEnum.WELLPLATE_OVERPACK)
        }

        return mappedRoles;
    }
}